// extracted by mini-css-extract-plugin
module.exports = {"AdPurchase":"AdPurchase_AdPurchase__y_q7O","purchaseButton":"AdPurchase_purchaseButton__1Ny0W"};